// import React, { useEffect } from "react";
// import { useAppDispatch, useAppSelector } from "../../app/hooks";
// import {
//   emailVerificationMail,
//   getLoginDetailsByID,
//   updateUserEmail,
// } from "./services/myprofile.services";
// import Loading from "../../components/spinner/Loading";
// import { VscVerifiedFilled } from "react-icons/vsc";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { FaEdit } from "react-icons/fa";
// import { getLocalItem } from "../../_helpers/storageUtils";
// import Modal from "../../components/modal/Modal";

// const LoginDetails = () => {
//   const dispatch = useAppDispatch();
//   const loginData = useAppSelector((state) => state.profile.loginData);
//   const loginLoading = useAppSelector((state) => state.profile.loginLoading);
//   const emailverificationLoading = useAppSelector(
//     (state) => state.profile.emailverificationLoading
//   );
//   const [showModel, setShowModel] = React.useState(false);

//   useEffect(() => {
//     dispatch(getLoginDetailsByID({ user_guid: getLocalItem("user_guid") }));
//   }, []);

//   const formik = useFormik({
//     initialValues: {
//       email_id: loginData?.email_id || "",
//     },
//     validationSchema: Yup.object({
//       email_id: Yup.string()
//         .email("Invalid email address")
//         .required("Email is required"),
//     }),
//     onSubmit: async (values, { setSubmitting, resetForm }) => {
//       const payload = {
//         email_id: values?.email_id ? values?.email_id : "",
//         user_guid: getLocalItem("user_guid"),
//       };
//       const response = await dispatch(updateUserEmail(payload));
//       if (response.meta.requestStatus === "fulfilled") {
//         setSubmitting(false);
//         resetForm();
//         setShowModel(false);
//         dispatch(getLoginDetailsByID({ user_guid: getLocalItem("user_guid") }));
//       }
//     },
//     enableReinitialize: true,
//   });

//   return (
//     <div className="position-relative">
//       <Loading loading={loginLoading} />
//       <div className="profile-heading">
//         <div className="prfile-name">
//           <h2>Login Details</h2>
//           <p>Manage your email address and mobile number</p>
//         </div>
//         <Modal
//           isOpen={showModel}
//           onClose={() => setShowModel(false)}
//           title={"Add Your Email ID"}
//           maxWidth={450}
//         >
//           <form className="add-travel">
//             <div
//               tabIndex={-1}
//               aria-labelledby="edit-profile"
//               aria-hidden="true"
//             >
//               <div>
//                 <div className="modal-content">
//                   <div className="travel-form-detail">
//                     <div className="travel-form">
//                       <form>
//                         <div className="field w-100">
//                           <label
//                             className={
//                               formik.touched.email_id && formik.errors.email_id
//                                 ? "error-label"
//                                 : ""
//                             }
//                           >
//                             Email ID <code>*</code>
//                           </label>
//                           <input
//                             type="email"
//                             name="email_id"
//                             value={formik.values.email_id}
//                             onChange={formik.handleChange}
//                             onBlur={formik.handleBlur}
//                             className={
//                               formik.touched.email_id && formik.errors.email_id
//                                 ? "error-border"
//                                 : ""
//                             }
//                           />
//                           {formik.touched.email_id &&
//                           formik.errors.email_id &&
//                           typeof formik.errors.email_id === "string" ? (
//                             <div className="error-label">
//                               {formik.errors.email_id}
//                             </div>
//                           ) : null}
//                         </div>
//                       </form>
//                     </div>
//                     <div className="travel-detail-btns mt-4">
//                       <a
//                         className="disable"
//                         href="javascript:void(0)"
//                         onClick={() => formik.resetForm()}
//                       >
//                         Cancel
//                       </a>
//                       <a
//                         href="javascript:void(0)"
//                         onClick={() => formik.handleSubmit()}
//                       >
//                         Save
//                       </a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </form>
//         </Modal>
//       </div>
//       <div className="travel-table">
//         <table>
//           <tbody>
//             <tr>
//               <td className="w-40">Mobile Number</td>
//               <td>
//                 <div className="profile-email-wrapper">
//                   <span>{loginData?.mobile_no}</span>
//                   <span className="email-verified">
//                     <VscVerifiedFilled /> Verified
//                   </span>
//                 </div>
//               </td>
//             </tr>
//             <tr>
//               <td>Email ID</td>
//               <td>
//                 {loginData?.email_id ? (
//                   <div className="profile-email-wrapper">
//                     <span className="loggedin-email">
//                       {loginData?.email_id}{" "}
//                       <FaEdit
//                         className="edit-icon"
//                         onClick={() => setShowModel(true)}
//                       />
//                     </span>
//                     {loginData?.is_email_verified ? (
//                       <span className="email-verified">
//                         <VscVerifiedFilled /> Verified
//                       </span>
//                     ) : (
//                       <>
//                         {!emailverificationLoading ? (
//                           <a
//                             href="javascript:void(0)"
//                             className="verify-email"
//                             onClick={() => {
//                               dispatch(
//                                 emailVerificationMail({
//                                   user_guid: getLocalItem("user_guid"),
//                                 })
//                               );
//                             }}
//                           >
//                             click here to verify
//                           </a>
//                         ) : (
//                           <span>email sending...</span>
//                         )}
//                       </>
//                     )}
//                   </div>
//                 ) : (
//                   <span
//                     className="profile-add-span"
//                     onClick={() => setShowModel(true)}
//                   >
//                     + Add your Email ID
//                   </span>
//                 )}
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// };

// export default LoginDetails;

import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  emailVerificationMail,
  getLoginDetailsByID,
  mobileNoVerificationOtp,
  mobileVerification,
  updateUserEmail,
  updateUserMobileNo,
} from "./services/myprofile.services";
import Loading from "../../components/spinner/Loading";
import { VscVerifiedFilled } from "react-icons/vsc";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FaEdit } from "react-icons/fa";
import { getLocalItem } from "../../_helpers/storageUtils";
import Modal from "../../components/modal/Modal";

const LoginDetails = () => {
  const dispatch = useAppDispatch();
  const loginData = useAppSelector((state) => state.profile.loginData);
  const loginLoading = useAppSelector((state) => state.profile.loginLoading);
  const emailverificationLoading = useAppSelector(
    (state) => state.profile.emailverificationLoading
  );
  const mobileVerificationLoading = useAppSelector(
    (state) => state.profile.mobileverificationLoading
  );

  const [showEmailModal, setShowEmailModal] = React.useState(false);
  const [showMobileModal, setShowMobileModal] = React.useState(false);
  const [showOtpModal, setShowOtpModal] = React.useState(false);

  useEffect(() => {
    dispatch(getLoginDetailsByID({ user_guid: getLocalItem("user_guid") }));
  }, []);

  // -------- Email Update Form --------
  const emailFormik = useFormik({
    initialValues: {
      email_id: loginData?.email_id || "",
    },
    validationSchema: Yup.object({
      email_id: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const payload = {
        email_id: values?.email_id || "",
        user_guid: getLocalItem("user_guid"),
      };
      const response = await dispatch(updateUserEmail(payload));
      if (response.meta.requestStatus === "fulfilled") {
        setSubmitting(false);
        resetForm();
        setShowEmailModal(false);
        dispatch(getLoginDetailsByID({ user_guid: getLocalItem("user_guid") }));
      }
    },
    enableReinitialize: true,
  });

  // -------- Mobile Update Form --------
  const mobileFormik = useFormik({
    initialValues: {
      mobile_no: loginData?.mobile_no || "",
    },
    validationSchema: Yup.object({
      mobile_no: Yup.string()
        .matches(/^[0-9]{10}$/, "Enter valid 10-digit mobile number")
        .required("Mobile number is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const payload = {
        mobile_no: values?.mobile_no ? `${values?.mobile_no}` : "",
        user_guid: getLocalItem("user_guid"),
      };
      const response = await dispatch(updateUserMobileNo(payload));
      if (response.meta.requestStatus === "fulfilled") {
        setSubmitting(false);
        resetForm();
        setShowMobileModal(false);
        dispatch(getLoginDetailsByID({ user_guid: getLocalItem("user_guid") }));
      }
    },
    enableReinitialize: true,
  });

  // -------- OTP Form --------
  const otpFormik = useFormik({
    initialValues: {
      otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .matches(/^[0-9]{4,6}$/, "Enter valid OTP")
        .required("OTP is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      const response = await dispatch(
        mobileVerification({
          user_guid: getLocalItem("user_guid"),
          otp: values.otp ? `${values.otp}` : "",
        })
      );
      if (response.meta.requestStatus === "fulfilled") {
        localStorage.setItem("is_mobile_verified", "true");
        setSubmitting(false);
        resetForm();
        setShowOtpModal(false);
        dispatch(getLoginDetailsByID({ user_guid: getLocalItem("user_guid") }));
      }
    },
  });

  return (
    <div className="position-relative">
      <Loading loading={loginLoading} />
      <div className="profile-heading">
        <div className="prfile-name">
          <h2>Login Details</h2>
          <p>Manage your email address and mobile number</p>
        </div>

        {/* Email Modal */}
        <Modal
          isOpen={showEmailModal}
          onClose={() => {
            setShowEmailModal(false);
            emailFormik.resetForm();
          }}
          title={"Add Your Email ID"}
          maxWidth={450}
        >
          <form className="add-travel">
            <div>
              <div className="modal-content">
                <div className="travel-form-detail">
                  <div className="travel-form">
                    <form>
                      <div className="field w-100">
                        <label
                          className={
                            emailFormik.touched.email_id &&
                            emailFormik.errors.email_id
                              ? "error-label"
                              : ""
                          }
                        >
                          Email ID <code>*</code>
                        </label>
                        <input
                          type="email"
                          name="email_id"
                          value={emailFormik.values.email_id}
                          onChange={emailFormik.handleChange}
                          onBlur={emailFormik.handleBlur}
                          className={
                            emailFormik.touched.email_id &&
                            emailFormik.errors.email_id
                              ? "error-border"
                              : ""
                          }
                        />
                        {emailFormik.touched.email_id &&
                        emailFormik.errors.email_id &&
                        typeof emailFormik.errors.email_id === "string" ? (
                          <div className="error-label">
                            {emailFormik.errors.email_id}
                          </div>
                        ) : null}
                      </div>
                    </form>
                  </div>
                  <div className="travel-detail-btns mt-4">
                    <a
                      className="disable"
                      href="javascript:void(0)"
                      onClick={() => {
                        emailFormik.resetForm();
                        setShowEmailModal(false);
                      }}
                    >
                      Cancel
                    </a>
                    <a
                      href="javascript:void(0)"
                      onClick={() => emailFormik.handleSubmit()}
                    >
                      Save
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>

        {/* Mobile Modal */}
        <Modal
          isOpen={showMobileModal}
          onClose={() => {
            mobileFormik.resetForm();
            setShowMobileModal(false);
          }}
          title={"Add Your Mobile Number"}
          maxWidth={450}
        >
          <form className="add-travel">
            <div>
              <div className="modal-content">
                <div className="travel-form-detail">
                  <div className="travel-form">
                    <form>
                      <div className="field w-100">
                        <label
                          className={
                            mobileFormik.touched.mobile_no &&
                            mobileFormik.errors.mobile_no
                              ? "error-label"
                              : ""
                          }
                        >
                          Mobile Number <code>*</code>
                        </label>
                        <input
                          type="number"
                          name="mobile_no"
                          value={mobileFormik.values.mobile_no}
                          onChange={mobileFormik.handleChange}
                          onBlur={mobileFormik.handleBlur}
                          onInput={(e: any) => {
                            return (e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 10));
                          }}
                          className={
                            mobileFormik.touched.mobile_no &&
                            mobileFormik.errors.mobile_no
                              ? "error-border"
                              : ""
                          }
                        />
                        {mobileFormik.touched.mobile_no &&
                        mobileFormik.errors.mobile_no &&
                        typeof mobileFormik.errors.mobile_no === "string" ? (
                          <div className="error-label">
                            {mobileFormik.errors.mobile_no}
                          </div>
                        ) : null}
                      </div>
                    </form>
                  </div>
                  <div className="travel-detail-btns mt-4">
                    <a
                      className="disable"
                      href="javascript:void(0)"
                      onClick={() => {
                        mobileFormik.resetForm();
                        setShowMobileModal(false);
                      }}
                    >
                      Cancel
                    </a>
                    <a
                      href="javascript:void(0)"
                      onClick={() => mobileFormik.handleSubmit()}
                    >
                      Save
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>

        {/* OTP Modal */}
        <Modal
          isOpen={showOtpModal}
          onClose={() => {
            otpFormik.resetForm();
            setShowOtpModal(false);
          }}
          title={"Verify Mobile Number"}
          maxWidth={450}
        >
          <form className="add-travel">
            <div>
              <div className="modal-content">
                <div className="travel-form-detail">
                  <div className="travel-form">
                    <form>
                      <div className="field w-100">
                        <label
                          className={
                            otpFormik.touched.otp && otpFormik.errors.otp
                              ? "error-label"
                              : ""
                          }
                        >
                          Enter OTP <code>*</code>
                        </label>
                        <input
                          type="number"
                          name="otp"
                          value={otpFormik.values.otp}
                          onChange={otpFormik.handleChange}
                          onBlur={otpFormik.handleBlur}
                          onInput={(e: any) => {
                            return (e.target.value = Math.max(
                              0,
                              parseInt(e.target.value)
                            )
                              .toString()
                              .slice(0, 4));
                          }}
                          className={
                            otpFormik.touched.otp && otpFormik.errors.otp
                              ? "error-border"
                              : ""
                          }
                        />
                        {otpFormik.touched.otp && otpFormik.errors.otp ? (
                          <div className="error-label">
                            {otpFormik.errors.otp}
                          </div>
                        ) : null}
                      </div>
                    </form>
                  </div>
                  <div className="travel-detail-btns mt-4">
                    <a
                      className="disable"
                      href="javascript:void(0)"
                      onClick={() => {
                        otpFormik.resetForm();
                        setShowOtpModal(false);
                      }}
                    >
                      Cancel
                    </a>
                    <a
                      href="javascript:void(0)"
                      onClick={() => otpFormik.handleSubmit()}
                    >
                      Verify
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </Modal>
      </div>

      {/* Main Table */}
      <div className="travel-table">
        <table>
          <tbody>
            {/* Mobile */}
            <tr>
              <td className="w-40">Mobile Number</td>
              <td>
                {loginData?.mobile_no ? (
                  <div className="profile-email-wrapper">
                    <span className="loggedin-email">
                      {loginData?.mobile_no}{" "}
                      {/* {localStorage.getItem("login_with") !== "mobile" && ( */}
                      <FaEdit
                        className="edit-icon"
                        onClick={() => setShowMobileModal(true)}
                      />
                      {/* )} */}
                    </span>
                    {loginData?.is_mobile_verified ? (
                      <span className="email-verified">
                        <VscVerifiedFilled /> Verified
                      </span>
                    ) : (
                      <>
                        {!mobileVerificationLoading ? (
                          <a
                            href="javascript:void(0)"
                            className="verify-email"
                            onClick={async () => {
                              const response = await dispatch(
                                mobileNoVerificationOtp({
                                  mobile_no: mobileFormik.values.mobile_no,
                                })
                              );
                              if (response.meta.requestStatus === "fulfilled") {
                                setShowOtpModal(true);
                              }
                            }}
                          >
                            click here to verify
                          </a>
                        ) : (
                          <span>otp sending...</span>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <span
                    className="profile-add-span"
                    onClick={() => setShowMobileModal(true)}
                  >
                    + Add your Mobile Number
                  </span>
                )}
              </td>
            </tr>

            {/* Email */}
            <tr>
              <td>Email ID</td>
              <td>
                {loginData?.email_id ? (
                  <div className="profile-email-wrapper">
                    <span className="loggedin-email">
                      {loginData?.email_id}{" "}
                      {/* {localStorage.getItem("login_with") !== "email" && ( */}
                      <FaEdit
                        className="edit-icon"
                        onClick={() => setShowEmailModal(true)}
                      />
                      {/* )} */}
                    </span>
                    {loginData?.is_email_verified ? (
                      <span className="email-verified">
                        <VscVerifiedFilled /> Verified
                      </span>
                    ) : (
                      <>
                        {!emailverificationLoading ? (
                          <a
                            href="javascript:void(0)"
                            className="verify-email"
                            onClick={() => {
                              dispatch(
                                emailVerificationMail({
                                  user_guid: getLocalItem("user_guid"),
                                })
                              );
                            }}
                          >
                            click here to verify
                          </a>
                        ) : (
                          <span>email sending...</span>
                        )}
                      </>
                    )}
                  </div>
                ) : (
                  <span
                    className="profile-add-span"
                    onClick={() => setShowEmailModal(true)}
                  >
                    + Add your Email ID
                  </span>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default LoginDetails;
